import 'react-datepicker/dist/react-datepicker.css';
import 'react-select/dist/react-select.css';
// import 'semantic-ui-css/semantic.min.css';
import React, { Component } from 'react';
import { persistStore } from 'redux-persist';
import { Provider } from 'react-redux';
import moment from 'moment';
import { ApolloProvider } from 'react-apollo';
import { LocalizeProvider } from 'react-localize-redux';
import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { CONFIG } from './config';
import store from './store';
import HHRouter from './hhRouter';
import HHApolloClient from './hhApolloClient';
import ErrorBoundary from './components/errorBoundary';

Sentry.init({
  dsn: CONFIG.SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing()
  ],
  tracesSampleRate: 0.7 // Be sure to lower this in production
});

class AppContainer extends Component {
  constructor() {
    super();
    this.state = { rehydrated: false };
  }

  componentWillMount() {
    persistStore(store, {}, () => {
      this.setState({ rehydrated: true });
    });
  }

  async componentDidUpdate() {
    const heapAnalytic = document.createElement('script');
    heapAnalytic.type = 'text/javascript';
    heapAnalytic.async = true;
    let heapSrc = null;

    if (
      store.getState().user.profile !== undefined
    ) {
      // add heap user identity
      const userInfo = store.getState().user.profile.basicInfo;
      const userId = userInfo.id || '0';
      heapSrc = document.createTextNode(`${CONFIG.HEAP_ANALYTIC_CODE}heap.identify("${userId}");`);
    } else {
      heapSrc = document.createTextNode(CONFIG.HEAP_ANALYTIC_CODE);
    }

    heapAnalytic.appendChild(heapSrc);
    const x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(heapAnalytic, x);
  }

  loadIntercom = () => {
    if (
      store.getState().user.profile !== undefined &&
      store.getState().user.intercomEnabled
    ) {
      const userInfo = store.getState().user.profile.basicInfo;
      window.intercomSettings = {
        app_id: CONFIG.INTERCOM_ID,
        email: userInfo.email || 'new@hackhub.com',
        user_id: userInfo.id || '0',
        created_at: moment(),
        subdomain: 'none',
        custom_domain: 'hackhub.com',
        name: userInfo.name || 'Visitor',
        phone: userInfo.phone || '+16041234567'
      };
    } else if (store.getState().user.intercomEnabled) {
      window.intercomSettings = {
        app_id: CONFIG.INTERCOM_ID,
        custom_domain: 'hackhub.com'
      };
    } else {
      return null;
    }

    /* eslint-disable */
    (function () {
      function l() {
        const s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/x7qa9stv';
        const x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      }
      const w = window;
      const ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', window.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();
    return;
  };

  render() {
    if (!this.state.rehydrated) {
      return <div className='loading'>Loading...</div>;
    }

    return (
      <ErrorBoundary>
        <Provider store={store}>
          <LocalizeProvider>
            <ApolloProvider client={HHApolloClient}>
              <HHRouter />
            </ApolloProvider>
          </LocalizeProvider>
        </Provider>
      </ErrorBoundary>
    );
  }
}

export default AppContainer;



// WEBPACK FOOTER //
// ./src/container.js